import { StorageService } from '@/services/storage.service'
import { ExtensibleSMSService, ExtensibleSMSError } from '@/services/extensible-sms.service'
import {extensibleTypes} from '@/constants'

const state = {
    mediaTypes: [],
    extensibles: {texts: [], images: [], videos: [], audios: [], surveys: [], votes: [], polls: []},
    loading: false,
    currentPage: 1,
    total: 0,
    pages: 0,
    serverResponse: null,
}

const getters = {
    mediaTypes: (state) => {
        return state.mediaTypes
    },

    extensibles: (state) => {
        return state.extensibles
    },

    loading: (state) => {
        return state.loading
    },

    currentPage: (state) => {
        return state.currentPage
    },

    total: (state) => {
        return state.total
    },

    pages: (state) => {
        return state.pages
    },

    serverResponse: (state) => {
        return state.serverResponse
    },
}

const actions = {
    async fetchAll({ commit }, { data }) {
        commit('startRequest')
        try {
            const response = await ExtensibleSMSService.fetchAll(data)
            if (response.hasOwnProperty('messages')) {
                response.type = data.type
                commit('fetchAllSuccess', response)

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof ExtensibleSMSError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async mediaTypeFetchAll({ commit }, { data }) {
        // commit('startRequest');
        try {
            const response = await ExtensibleSMSService.mediaTypeFetchAll(data);
            if (response.hasOwnProperty('mediaTypes')) {

                commit('mediaTypeFetchAllSuccess', response)

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof ExtensibleSMSError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async createExtensibleSms({ commit }, { data, type }) {
        commit('startRequest')
        try {
            const response = await ExtensibleSMSService.createExtensibleSms(data)
            
            if (response.code === 200) {
                const fetchResponse = await ExtensibleSMSService.fetchAll({uuid:data.uuid, type:type})
                if (fetchResponse.hasOwnProperty('messages')) {
                    fetchResponse.type = type
                    commit('fetchAllSuccess', fetchResponse)
                }

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof ExtensibleSMSError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async createQuestionnaire({ commit }, { data, type }) {
        commit('startRequest')
        try {
            const response = await ExtensibleSMSService.createQuestionnaire(data)
            
            if (response.code === 200) {
                const fetchResponse = await ExtensibleSMSService.fetchAll({uuid:data.uuid, type:type})
                if (fetchResponse.hasOwnProperty('messages')) {
                    fetchResponse.type = type
                    commit('fetchAllSuccess', fetchResponse)
                }

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof ExtensibleSMSError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
    
    async fetchReviews({ commit }, { data }) {
        commit('startRequest')
        try {
            const response = await ExtensibleSMSService.fetchReviews(data.id)
            if (response.hasOwnProperty('reviews')) {
                response.id = data.id
                response.type = data.type
                commit('fetchReviewsSuccess', response)

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof ExtensibleSMSError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
    async delete({ commit }, { data }) {
        commit('startRequest')
        try {
            const response = await ExtensibleSMSService.delete(data)
            if (response.code === 200) {
                commit('deleteSuccess', data)

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof ExtensibleSMSError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
    async reloadQuestionnaire({ commit }, { data }) {
        commit('startRequest')
        try {
            const response = await ExtensibleSMSService.reloadQuestionnaire(data.id, data.uuid)
            
            if (response.hasOwnProperty('id')) {
                commit('reloadQuestionnaireSuccess', {questionnaire: response, type: data.qType})

                return response
            } else {
                commit('requestError', response)
                
                return null
            }
        } catch (e) {
            if (e instanceof ExtensibleSMSError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
}

const mutations = {
    startRequest(state) {
        state.loading = true;
    },

    mediaTypeFetchAllSuccess(state, response) {
        state.mediaTypes = response.mediaTypes
        state.loading = false
    },

    fetchAllSuccess(state, response){
        state.loading = false
        switch (response.type) {
            case extensibleTypes.text:
                state.extensibles.texts = response.messages
                break
            case extensibleTypes.image:
                state.extensibles.images = response.messages
                break
            case extensibleTypes.audio:
                state.extensibles.audios = response.messages
                break
            case extensibleTypes.video:
                state.extensibles.videos = response.messages
                break
            case extensibleTypes.survey:
                state.extensibles.surveys = response.messages
                break
            case extensibleTypes.vote:
                state.extensibles.votes = response.messages
                break
            case extensibleTypes.poll:
                state.extensibles.polls = response.messages
                break
        }
    },

    createExtensibleSmsSuccess(state, response, type){
        switch (type) {
            case extensibleTypes.text:
                state.extensibles.texts = response
                break
            case extensibleTypes.image:
                state.extensibles.images = response
                break
            case extensibleTypes.audio:
                state.extensibles.audios = response
                break
            case extensibleTypes.video:
                state.extensibles.videos = response
                break
            case extensibleTypes.survey:
                state.extensibles.surveys = response
                break
            case extensibleTypes.vote:
                state.extensibles.votes = response
                break
            case extensibleTypes.poll:
                state.extensibles.polls = response
                break
        }
        
        state.loading = false
    },

    fetchReviewsSuccess(state, response){
        switch (response.type) {
            case 1:
                for (let j = 0; j < state.extensibles.texts.length; j++) {
                    if (state.extensibles.texts[j].id === response.id) {
                        state.extensibles.texts[j].reviews = response.reviews
                        break
                    }
                }
                break
            case 2:
                for (let j = 0; j < state.extensibles.images.length; j++) {
                    if (state.extensibles.images[j].id === response.id) {
                        state.extensibles.images[j].reviews = response.reviews
                        break
                    }
                }
                break
            case 3:
                for (let j = 0; j < state.extensibles.videos.length; j++) {
                    if (state.extensibles.videos[j].id === response.id) {
                        state.extensibles.videos[j].reviews = response.reviews
                        break
                    }
                }
                break
            case 4:
                for (let j = 0; j < state.extensibles.audios.length; j++) {
                    if (state.extensibles.audios[j].id === response.id) {
                        state.extensibles.audios[j].reviews = response.reviews
                        break
                    }
                }
                break
        }
        
        state.loading = false
    },

    deleteSuccess(state, data) {
        state.loading = false
        if (data.hasOwnProperty('eType')) {
            switch (data.eType) {
                case 1:
                    for (let j = 0; j < state.extensibles.texts.length; j++) {
                        if (state.extensibles.texts[j].id === data.id) {
                            state.extensibles.texts.splice(j, 1)
                            break
                        }
                    }
                    break
                case 2:
                    for (let j = 0; j < state.extensibles.images.length; j++) {
                        if (state.extensibles.images[j].id === data.id) {
                            state.extensibles.images.splice(j, 1)
                            break
                        }
                    }
                    break
                case 3:
                    for (let j = 0; j < state.extensibles.videos.length; j++) {
                        if (state.extensibles.videos[j].id === data.id) {
                            state.extensibles.videos.splice(j, 1)
                            break
                        }
                    }
                    break
                case 4:
                    for (let j = 0; j < state.extensibles.audios.length; j++) {
                        if (state.extensibles.audios[j].id === data.id) {
                            state.extensibles.audios.splice(j, 1)
                            break
                        }
                    }
                    break
            }
        } else {
            switch (data.qType) {
                case 1:
                    for (let j = 0; j < state.extensibles.surveys.length; j++) {
                        if (state.extensibles.surveys[j].id === data.id) {
                            state.extensibles.surveys.splice(j, 1)
                            break
                        }
                    }
                    break
                case 2:
                    for (let j = 0; j < state.extensibles.votes.length; j++) {
                        if (state.extensibles.votes[j].id === data.id) {
                            state.extensibles.votes.splice(j, 1)
                            break
                        }
                    }
                    break
                case 3:
                    for (let j = 0; j < state.extensibles.polls.length; j++) {
                        if (state.extensibles.polls[j].id === data.id) {
                            state.extensibles.polls.splice(j, 1)
                            break
                        }
                    }
                    break
            }
        }
    },

    reloadQuestionnaireSuccess(state, response) {
        switch (response.type) {
            case 1:
                for (let j = 0; j < state.extensibles.surveys.length; j++) {
                    if (state.extensibles.surveys[j].id === response.questionnaire.id) {
                        state.extensibles.surveys[j] = response.questionnaire
                        break
                    }
                }
                break
            case 2:
                for (let j = 0; j < state.extensibles.votes.length; j++) {
                    if (state.extensibles.votes[j].id === response.questionnaire.id) {
                        state.extensibles.votes[j] = response.questionnaire
                        break
                    }
                }
                break
            case 3:
                for (let j = 0; j < state.extensibles.polls.length; j++) {
                    if (state.extensibles.polls[j].id === response.questionnaire.id) {
                        state.extensibles.polls[j] = response.questionnaire
                        break
                    }
                }
                break
        }
    },

    stopRequest(state) {
        state.loading = false
    },

    requestError(state, response) {
        state.loading = false
        state.serverResponse = response
    },
}

export const extensibleSms = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}